<template>
    <div v-show="FormInputs.EyeDoctorInformation" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
            Eye Doctor Information
        </div>
        <!-- <div style="margin: 10px 0px" v-show="FormInputs.NonProfitOrganizationDetails" hidden> -->
        <div style="margin: 10px 0px" v-show="false">
            <div class="form-check">
                <input type="checkbox" v-on:click="Account.NoEyeDoctor = !Account.NoEyeDoctor" class="form-check-input">
                <label class="form-check-label">I do not have an eye doctor to add at this time</label>
            </div>
            <p v-if="!Account.NoEyeDoctor">
                <i>
                    <small>You will need to enter all the following information when placing an order</small>
                </i>
            </p>
        </div>
        <div v-if="!Account.NoEyeDoctor">
            <p v-if="FormInputs.BusinessLabels">
                Please list the information for at least one eye doctor. You can add more later under My Account page.
            </p>
            <p v-if="FormInputs.NonProfitLabels">
                Please list the information for at least one eye doctor you contract with or work with regularly. You can add more later under My Account page.
            </p>
            <div class="row" v-for="(doctor, index) in Account.EyeDoctors">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>NPI Number
                                    <span v-if="Account.UseLicenseNumber || (!doctor.UseLicenseNumber && !Account.NoEyeDoctor)">*</span>
                                    <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large">
                                        <i class="fa fa-question-circle-o"></i>
                                    </span>
                                </label>
                                <input type="text" maxlength="10" v-on:paste="pasteNpiNumber($event)" v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-on:keyup="ValidateNpiNumberEyeDoctor(index)" v-on:keypress="G_NumberCheck(this.event)" v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber }" v-model="doctor.NpiNumber" class="form-control" >
                                <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber">{{EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber}}</p>
                                <p class="error-message" v-if="invalidNpiNumberPaste">Sorry, only numeric NPI values can be pasted here.</p>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Relationship*
                                    <span v-bind:data-balloon="relationshipTooltip" data-balloon-pos="down" data-balloon-length="large">
                                        <i class="fa fa-question-circle-o"></i>
                                    </span>
                                </label>
                                <select v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorRole }" v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-model="doctor.Role" class="form-control" style="height:36.5px;">
                                    <!-- <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option> -->
                                    <option>Self</option>
                                    <option>Employee</option>
                                    <option>Contractor</option>
                                    <option>Unaffiliated</option>
                                    <option>Other</option>
                                </select>
                                <!-- <input type="text" maxlength="10" v-model="Account.Relationship" v-bind:class="{ error_field: AccountValidationResult.AccountRelationship }" class="form-control"> -->
                                <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorRole">{{EyeDoctorValidation[index].validationResult.EyeDoctorRole}}</p>
                            </div>
                        </div>




















                        <!--<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Affiliation with Account
                                    <span >*</span>
                            <span v-bind:data-balloon="doctorAffiliationToolTip" data-balloon-pos="down" data-balloon-length="large">
                                        <i class="fa fa-question-circle-o"></i>
                                    </span>
                                </label>
                                    <div class="form-group" >
                                        <select v-model="Account.PrimaryContact.Affiliation" class="form-control">
                                            <option>Self</option>
                                            <option>Employee (Part Time)</option>
                                            <option>Employee (Full Time)</option>
                                            <option>Contractor</option>
                                            <option>Unaffiliated</option>
                                            <option>Volunteer</option>
                                            <option>Other</option>
                                        </select>
                                    </div>                                  <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber">{{EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber}}</p>
                            </div>
                        </div>-->
                        <div v-if="!doctor.UseLicenseNumber" class="col-lg-4 col-md-4 col-sm-4 col-xs-4">

                        </div>
                        <div v-if="doctor.UseLicenseNumber" class="col-lg-8  col-md-8  col-sm-12  col-xs-12">
                            <div class="form-group">
                                <label>License Number
                                    <span v-if="!Account.NoEyeDoctor">*</span>
                                </label>
                                <input maxlength="18" v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber }" v-model="doctor.LicenseNumber" type="text" class="form-control">
                                <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber">{{EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber}}</p>
                            </div>
                        </div>
                        <div v-if="doctor.UseLicenseNumber" class="col-lg-4  col-md-4  col-sm-12  col-xs-12">
                            <div class="form-group">
                                <label>State
                                    <span v-if="!Account.NoEyeDoctor">*</span>
                                </label>
                                <select v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorState }" v-model="doctor.State" class="form-control" style="height: 36.5px;">
                                    <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                </select>
                                <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorState">{{EyeDoctorValidation[index].validationResult.EyeDoctorState}}</p>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check">
                                <input v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-on:click="doctor.UseLicenseNumber = !doctor.UseLicenseNumber"  type="checkbox" class="form-check-input">
                                <label class="form-check-label">Use License Number</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!--changes here-->
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Doctor's First Name
                            <span v-if="!Account.NoEyeDoctor">*</span>
                        </label>
                        <input v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorFirstName }" v-model="doctor.FirstName" type="text" class="form-control capitalize">
                        <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorFirstName">{{EyeDoctorValidation[index].validationResult.EyeDoctorFirstName}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Doctor's Last Name
                            <span v-if="!Account.NoEyeDoctor">*</span>
                        </label>
                        <input v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorLastName }" v-model="doctor.LastName" type="text" class="form-control capitalize">
                        <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorLastName">{{EyeDoctorValidation[index].validationResult.EyeDoctorLastName}}</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Suffix
                            <span v-if="!Account.NoEyeDoctor">*</span>
                        </label>
                        <select v-bind:disabled="Account.PrimaryContact.IsEyeDoctor && index == 0" v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorSuffix }" v-model="doctor.Suffix" class="form-control" style="height: 36.5px;">
                            <option v-for="(value, key) in Suffix" v-bind:value="key">{{key}}</option>
                        </select>
                        <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorSuffix">{{EyeDoctorValidation[index].validationResult.EyeDoctorSuffix}}</p>
                    </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Doctor's Email Address*</label>
                        <input v-bind:class="{ error_field: EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress || errors.has('email') }" v-model="doctor.EmailAddress" name="email" type="email" class="form-control" v-validate="'email'" data-vv-as="email" oninput="this.value = this.value.toLowerCase()">
                        <p class="error-message" v-show="errors.has('email') && !EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress">{{ errors.first('email') }}</p>
                        <p class="error-message" v-if="EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress">{{EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" v-show="Account.PrimaryContact.IsEyeDoctor && index != 0">
                    <div class="form-group">
                        <label>Year Licensed</label>
                        <input v-on:keypress="G_NumberCheck(this.event)" v-on:keyup="G_NumberOfYearsCheck(doctor, 'YearsInPractice')" v-model="doctor.YearsInPractice" maxlength="4" type="text" class="form-control" v-on:blur="CheckYearLicense(doctor.YearsInPractice)">
                        <!-- REAL TIME VALIDATION -->
                        <p v-if="errorMessage.year" class="error-message">{{errorMessage.year}}</p>
                    </div></div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="col-lg-12 offset-lg-5 col-md-12 col-sm-12 col-xs-12">
                        <button v-if="Account.EyeDoctors.length > 1 && !(Account.PrimaryContact.IsEyeDoctor && index === 0)" v-on:click="RemoveDoctor(index)" class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-font-size-17" >Delete </button>
                    </div><hr></div>
                </div>
                <div v-if="Account.EyeDoctors.length > 1" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <!-- <div class="account-section-divider"></div> -->
                </div>
            </div>
            <div class="row">
                <div class="evf-invite col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-8 offset-xs-0 center">
                    <button class="btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-main-blue--hover g-font-size-16 g-rounded-10 g-px-25 g-mb-10 g-mx-10" @click="AddDoctor()">Add Another Doctor</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: ["Account", "EyeDoctorValidation", "FormInputs", "Suffix", "State"],
  data() {
    return {
      errorMessage: {
        year: null
      },
      IsInputDisabled: false,
      invalidNpiNumberPaste: false,
    };
  },
  methods: {
    pasteNpiNumber(event) {
      var re = /^\d+$/;
      if (!re.test(event.clipboardData.getData('text'))) {
        this.invalidNpiNumberPaste = true;
      } else {
        this.invalidNpiNumberPaste = false;
      }
    },
    AddDoctor() {
      this.Account.EyeDoctors.push({
        NoEyeDoctor: false,
        UseLicenseNumber: false,
        NpiNumber: null,
        LicenseNumber: null,
        State: null,
        FirstName: null,
        LastName: null,
        Suffix: null,
        EmailAddress: null,
        YearsInPractice: null,
        Role: null

      });
            this.EyeDoctorValidation.push({ validationResult: {} });
            //   console.log("this.Account.EyeDoctors");
            //   console.log(this.Account.EyeDoctors);
              var size = Object.keys(this.Account.EyeDoctors).length;
            //   console.log("EyeDoctors Object size " + " "+ size);
              if (size > 1) {
                  var printNPINumber = size;
                //   console.log(this.Account.EyeDoctors[printNPINumber].NpiNumber);
                  // for(var i = 0; i > size.length;  i++) {
                  //     var getResult = size[i].this.Account.EyeDoctors[0].NpiNumber;
                  // // }
                  // console.log(getResult);
                //   console.log(this.Account.EyeDoctors[0].NpiNumber);
                  this.Account.EyeDoctors.NpiNumber = "Empty"
                  // this.Account.PrimaryContact.IsEyeDoctor = false;
                //   console.log("NpiNumber value is" + " " + this.Account.EyeDoctors.NpiNumber);
              }
    },
    // islicenseNumber() {
    //   if (Account.PrimaryContact.IsEyeDoctorsLicenseNumber) {
    //     this.doctor.UseLicenseNumber = true;
    //   }
    // },
    RemoveDoctor(index) {
      this.Account.EyeDoctors.splice(index, 1);
    },
    ValidateNpiNumberEyeDoctor(index) {
      console.log('ValidateNpiNumberEyeDoctor(index) => ', index);
      this.$emit("npiIsDirtyBusiness", index);
    },
    CheckYearLicense(yearPractice) {
      var year = yearPractice;
      var result = this.G_CheckYearLicense(year);
      if (result) this.errorMessage.year = result;
      else this.errorMessage.year = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// EyeDoctorInformation.vue?64ca8129